











































































































































































































const ExcelJS = require("exceljs");

import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import MemberCallSearch from "@/components/report/MemberCallSearch.vue";
import ListView from "@/components/report/MemberCallList.vue";
import { GapMemberCallReportFilter } from "@/store/modules/types";
import { jsPDF } from "jspdf";
//import moment from "moment"
import App from "@/App.vue";

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs,
    MemberCallSearch,
    /*     Pager,
    CalendarView, */
    ListView,

  },
  computed: {
    ...mapState("gaps", ["filter"]),
    /*  ...mapState("schedule", ["view", "list"]), */
    /*getDefaulthCampaign: function () {
      return this.$store.state.gaps.campaigns[0].id;
    },*/
  },
})
export default class MembersReport extends Vue {
  campaignId: string = "";
  filter!: GapMemberCallReportFilter;
  reportFilter = this.defaultFilter();
  pageRows: Array<any> = [];
  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.reportFilter = this.defaultFilter();
    this.getReport();
  }
/*
  defaultFilter(): GapReportFilter {
    return {
      insurerList: [],
      ipaList: [],
      priorityList: [],
      statusList: [],
      subStatusList: [],
      admissionDischargeList:[],
      referenceDate: {
        to: null,
        from: null,
      },
      campaignId: this.getDefaulthCampaign.id,
    };
  }*/

  defaultFilter(): GapMemberCallReportFilter {
    return {
      campaignId:null,
      createdDate: {
        from: this.$moment().format("MM/DD/YYYY"),
        to: this.$moment().format("MM/DD/YYYY")
      }
    };
  }

  async getReport() {
    
    //const { campaignId } = this.filter;
    try {
       if(!this.reportFilter.campaignId ||!this.reportFilter.createdDate.from || !this.reportFilter.createdDate.to){
         this.pageRows=[];
         return;
       }

       this.$store.commit("main/SET_LOADING", true);
      const data = await this.$store.dispatch(
        "gaps/getMemberCallReport",
        this.reportFilter
      );
      this.pageRows = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  get getDefaulthCampaign() {
    return this.$store.state.gaps.campaigns[0];
  }

   get getCampaignSelected() {
    return this.$store.state.gaps.campaigns.filter((c) => c.id === this.reportFilter.campaignId)[0];
  }

  get getEntity() {
    return this.$store.state.auth.user.entities.filter(
      (e) => e.id == this.$store.state.auth.entityId
    )[0];
  }

  exportExcel() {
       const moment2: any = this.$moment;
    /*const store = this.$store;
    this.$store.commit("main/SET_LOADING", true);*/
    var reportTitle = "MEMBER CALL LOG REPORT";
    var subtitle = this.getCampaignSelected.name;
    var fileName =
      "member_call_log_report_" + this.$moment().format("MMDDYYYY_hhmma");
    const reportDate = this.$moment()
      .format("MMM DD YYYY hh:mm A")
      .toUpperCase();
    const reportRangeDate ='FROM '+ (this.reportFilter.createdDate.from? moment2(this.reportFilter.createdDate.from).format("MM/DD/YYYY"):'-') +' TO  ' + (this.reportFilter.createdDate.to? moment2(this.reportFilter.createdDate.to).format("MM/DD/YYYY"):'-');
      /*"FROM " +
      this.$moment().format("MM/DD/YYYY") +
      " TO " +
      this.$moment().format("MM/DD/YYYY");*/
    const medicalOffice = this.getEntity.name;

    const header = [
      "Line",
      "Gap #",
      "Insurer",
      "Member ID",
      "Member Name",
      "Final Stage",
      "First Call Date",
      "Second Call Date",
      "Third Call Date",
      "Fourth Call Date",
      "Fifth Call Date",
      "Six Call Date",
      "Seventh Call Date",
      "Eight Call Date",
      "Status Contact",
      "Status",
      "Reason"
    ];
    const font = {
      name: "Calibri",
      family: 2,
      size: 16,
      underline: false,
      bold: true,
    };
    const alignment = {
      vertical: "middle",
      horizontal: "right",
    };
    const data: any = [];
    var total = 0;
    const moment: any = this.$moment;
    for (const member of this.pageRows) {
      var row: any = [];
      row.push(member.Line);
      row.push(member.GapID);
      row.push(member.Insurer);
      row.push(member.MemberID);
      row.push(member.MemberName);
      row.push(member.FinalStage);
      row.push(member.FirstCallDate? moment(member.FirstCallDate).format("MM/DD/YYYY hh:mm A"):'');
      row.push(member.SecondCallDate? moment(member.SecondCallDate).format("MM/DD/YYYY hh:mm A"):'');
      row.push(member.ThirdCallDate? moment(member.ThirdCallDate).format("MM/DD/YYYY hh:mm A"):'');
      row.push(member.FourthCallDate? moment(member.FourthCallDate).format("MM/DD/YYYY hh:mm A"):'');
      row.push(member.FifthCallDate? moment(member.FifthCallDate).format("MM/DD/YYYY hh:mm A"):'');
      row.push(member.SixCallDate? moment(member.SixCallDate).format("MM/DD/YYYY hh:mm A"):'');
      row.push(member.SeventhCallDate? moment(member.SeventhCallDate).format("MM/DD/YYYY hh:mm A"):'');
      row.push(member.EightCallDate? moment(member.EightCallDate).format("MM/DD/YYYY hh:mm A"):'');
      row.push(member.StatusContact);
      row.push(member.Status);
      row.push(member.Reason);
      data.push(row);
    }
    //Create workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "PatientCare";
    workbook.lastModifiedBy = "PatientCare";
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    const worksheet = workbook.addWorksheet("Report");

    //Add Row and formatting
    let reportTitleRow = (worksheet.getCell("H1").value = reportTitle);
    let reportDateRow = (worksheet.getCell("H2").value = reportDate);
    let medicalOfficeRow = (worksheet.getCell("H3").value = medicalOffice);
    let reportRangeDateRow = (worksheet.getCell("H4").value = reportRangeDate);

    // Set font, size and style in title row.
    worksheet.mergeCells("H1:I1");
    worksheet.mergeCells("H2:I2");
    worksheet.mergeCells("H3:I3");
    worksheet.mergeCells("H4:I4");

    worksheet.getCell("H1").font = font;
    worksheet.getCell("H2").font = font;
    worksheet.getCell("H3").font = font;
    worksheet.getCell("H4").font = font;

    worksheet.getCell("H1").alignment = alignment;
    worksheet.getCell("H2").alignment = alignment;
    worksheet.getCell("H3").alignment = alignment;
    worksheet.getCell("H4").alignment = alignment;

    //Add logo
    var img = new Image();

    img.onload = function () {
      var canvas: any = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      canvas = null;

      //Add Image
      let logo = workbook.addImage({
        base64: dataURL,
        extension: "png",
      });

      worksheet.addImage(logo, "A1:C4");
      worksheet.mergeCells("A1", "C4");

      // Blank Row
      worksheet.addRow([]);

      //Add waitingList row
      let subTitleRow = worksheet.addRow([subtitle]); //subtitle
      worksheet.mergeCells("A6:I6");

      subTitleRow.eachCell((cell, number) => {
        cell.border = {
          top: {
            style: "thin",
            color: {
              argb: "87CEEB",
            },
          },
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 14,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "87CEEB",
          },
          bgColor: {
            argb: "FFFFFF",
          },
        };
        cell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //add data
      worksheet.addRows(data);

      //column width
      //worksheet.getColumn(1).width = 30;
      //worksheet.getColumn(2).width = 30;
      worksheet.getColumn(3).width = 16;
      worksheet.getColumn(4).width = 16;
      worksheet.getColumn(5).width = 30;
      worksheet.getColumn(6).width = 16;
      worksheet.getColumn(7).width = 30;
      worksheet.getColumn(8).width = 30;
      worksheet.getColumn(9).width = 20;
      worksheet.getColumn(11).width = 20;
      worksheet.getColumn(13).width = 20;
      worksheet.getColumn(14).width = 20;
      worksheet.getColumn(15).width = 20;
      worksheet.getColumn(16).width = 20;
      /*worksheet.getColumn(17).width = 20;
      worksheet.getColumn(18).width = 20;
      worksheet.getColumn(19).width = 20;
      worksheet.getColumn(20).width = 60;
      worksheet.getColumn(21).width = 60;
      worksheet.getColumn(22).width = 60;
       worksheet.getColumn(23).width = 60;*/

      //Footer Row
      const footerFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FFFFFF",
        },
      };

      var emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`);

      let footerRow = worksheet.addRow(["Total: " + data.length + " Member Call"]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "service@waitingmed.com · www.waitingmed.com",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "Calle Luis Pales Matos FF-15, Levittown, PR 00949",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`);
      //save
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //app.saveAs(blob, fileName + '.xlsx');
        var url = window.URL.createObjectURL(blob);

        var doc = document.createElement("a");
        doc.href = url;
        doc.download = fileName + ".xlsx";
        doc.click();
        window.URL.revokeObjectURL(url);
      });
    };

    img.src = require("../assets/wmpc_logo.png");
  }

    async exportPDF() {
    this.$store.commit("main/SET_LOADING", true);
    var el = document.getElementById("report")!;
    const scale = 0.8;
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: [el.offsetWidth * scale, el.offsetHeight * scale + 50], //10
      //format: [1920 , el.offsetHeight * scale + 50], 
      //1536  201.20000000000002
      //format: [2114 * scale, 2314 * scale + 200]
    });

    doc.html(el, {
      html2canvas: {
        scale,
      },
      //HTMLOptions:options,
      callback: (doc) => {
        doc.save(
          "member_call_log_report_" + this.$moment().format("MMDDYYYY_hhmmA") + ".pdf"
        );
        this.$store.commit("main/SET_LOADING", false);
      },
      x: 0,
      y: 0,
    });
  }

  clearFilter() {
    this.reportFilter = this.defaultFilter();
    //this.$store.commit("gaps/RESET_FILTER");
    this.getReport();
  }

  mounted() {
    this.getReport();
  }
}
